import React from 'react';
import { createTheme } from '@material-ui/core';
import red from '@material-ui/core/colors/red';

declare module '@material-ui/core/styles/createPalette' {
    interface Palette {
        mainColor: React.CSSProperties['color'];
    }
    interface PaletteOptions {
        mainColor: React.CSSProperties['color'];
    }
    interface TypeBackground {
        card: React.CSSProperties['color'];
    }
}

const color = {
    main: '#007dc5',
};

export const theme = createTheme({
    overrides: {
        MuiAppBar: {
            colorPrimary: {
                backgroundColor: color.main,
            },
        },
        MuiTab: {
            root: {
                fontSize: 18,
            },
        },
        MuiLink: {
            root: {
                fontSize: 14,
                cursor: 'pointer',
            },
        },
        MuiFormLabel: {
            asterisk: {
                color: red['400'],
            },
        },
        MuiInputLabel: {
            asterisk: {
                color: red['400'],
            },
        },
    },
    palette: {
        primary: {
            main: '#007dc5',
            dark: '#164781',
        },
        mainColor: color.main,
        background: {
            card: '#e9ecf5',
        },
    },
    typography: {
        fontFamily: 'Noto Sans TC, sans-serif',
        h1: {
            fontSize: 32,
        },
    },
});
